// Plotly needs concrete colors rather than CSS variables. Keep presentation here;
// trace colors, heatmap scales, selected data, and axis ranges belong to widgets.
export const LIGHT_PLOT_COLORS = Object.freeze({
  paper: '#ffffff', surface: '#f8fafc', text: '#172033',
  grid: 'rgba(71, 85, 105, 0.18)', line: 'rgba(71, 85, 105, 0.32)',
  accent: '#0f766e',
});

const titleColor = (title, color) => typeof title === 'string'
  ? { text: title, font: { color } }
  : { ...title, font: { ...title?.font, color } };

const themeAxis = (axis = {}) => ({
  ...axis,
  color: LIGHT_PLOT_COLORS.text,
  gridcolor: LIGHT_PLOT_COLORS.grid,
  zerolinecolor: LIGHT_PLOT_COLORS.line,
  linecolor: LIGHT_PLOT_COLORS.line,
  tickfont: { ...axis.tickfont, color: LIGHT_PLOT_COLORS.text },
  ...(axis.title ? { title: titleColor(axis.title, LIGHT_PLOT_COLORS.text) } : {}),
});

export const applyPlotTheme = (layout = {}, theme) => {
  if (theme !== 'light') return layout;
  const colors = LIGHT_PLOT_COLORS;
  const themed = {
    ...layout,
    paper_bgcolor: colors.paper,
    plot_bgcolor: colors.surface,
    font: { ...layout.font, color: colors.text },
    ...(layout.title ? { title: titleColor(layout.title, colors.text) } : {}),
    hoverlabel: { ...layout.hoverlabel, bgcolor: colors.paper, bordercolor: colors.line,
      font: { ...layout.hoverlabel?.font, color: colors.text } },
    legend: { ...layout.legend, bgcolor: colors.paper, font: { ...layout.legend?.font, color: colors.text } },
    modebar: { ...layout.modebar, bgcolor: colors.paper, color: colors.text, activecolor: colors.accent },
  };
  for (const key of new Set(['xaxis', 'yaxis', ...Object.keys(layout).filter(key => /^[xy]axis\d*$/.test(key))])) {
    themed[key] = themeAxis(layout[key]);
  }
  if (layout.updatemenus) themed.updatemenus = layout.updatemenus.map(menu => ({
    ...menu, bgcolor: colors.paper, bordercolor: colors.line, font: { ...menu.font, color: colors.text },
  }));
  if (layout.scene) themed.scene = { ...layout.scene, bgcolor: colors.surface,
    xaxis: themeAxis(layout.scene.xaxis), yaxis: themeAxis(layout.scene.yaxis), zaxis: themeAxis(layout.scene.zaxis) };
  return themed;
};
